import { GameScene } from '../GameScene';
import { cursorCss, type GameCursor } from '../../ui/cursors';

/**
 * Gestión del cursor del juego: aplica el CSS del cursor (applyRawCursor, evitando writes redundantes),
 * lo resuelve por nombre (setGameCursor) y muestra el cursor de "agarrar/mover ventana" cuando se está
 * draggeando un panel (isAnyWindowDragging/updateDragCursor, chequeado por frame). Extraído de GameScene
 * (god-object). El estado (appliedCursorCss) vive en GameScene y se accede vía `this.scene.*`.
 */
export class CursorController {
  constructor(private scene: GameScene) {}

  public applyRawCursor(css: string): void {
    if (this.scene.appliedCursorCss === css) return;
    this.scene.appliedCursorCss = css;
    this.scene.input.setDefaultCursor(css);
  }

  public setGameCursor(name: GameCursor): void {
    this.applyRawCursor(cursorCss(name));
  }

  /** ¿Hay alguna ventana/panel o item siendo arrastrado? (para mostrar el cursor `drag`). */
  public isAnyWindowDragging(): boolean {
    return !!(
      this.scene.systemConsole?.isDraggingOrResizing() ||
      this.scene.inventoryPanel?.isDraggingPanel() ||
      this.scene.inventoryPanel?.isDraggingItem() ||
      this.scene.characterInfoPanel?.isDraggingPanel() ||
      this.scene.invokePanel?.isDraggingPanel() ||
      this.scene.animPanel?.isDraggingPanel() ||
      this.scene.particlePanel?.isDraggingPanel() ||
      this.scene.itemPanel?.isDraggingPanel() ||
      this.scene.bodyGalleryPanel?.isDraggingPanel() ||
      this.scene.weaponGalleryPanel?.isDraggingPanel() ||
      this.scene.charFrameDebugPanel?.isDraggingPanel() ||
      this.scene.spellsPanel?.isDraggingPanel() ||
      this.scene.spellsPanel?.isDraggingSpell() ||
      this.scene.spellQuickBar?.isDraggingSlot() ||
      this.scene.targets.targetPanel?.isDraggingOrResizing() ||
      this.scene.npcInfoPanel?.isDraggingPanel() ||
      this.scene.merchantPanel?.isDraggingPanel() ||
      this.scene.merchantPanel?.isDraggingItem() ||
      this.scene.spellVendorPanel?.isDraggingPanel()
    );
  }

  /**
   * Mantiene el cursor `drag` mientras se arrastra una ventana; al soltar, vuelve a `main` (sólo
   * si veníamos del cursor de drag, así no piso un hover de NPC/item). Se llama en pointermove/up.
   */
  public updateDragCursor(): void {
    if (this.isAnyWindowDragging()) {
      this.setGameCursor('drag');
    } else if (this.scene.appliedCursorCss === cursorCss('drag')) {
      this.setGameCursor('main');
    }
  }


}
